export * from "-!../../../../../node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!../../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./competencies.vue?vue&type=template&id=1bbc70a0&"


//////////////////
// WEBPACK FOOTER
// ./src/templates/components/base/modals/competencies.vue?vue&type=template&id=1bbc70a0&
// module id = 1375
// module chunks = 0